import { Navigate } from "react-router-dom";
import { hasAdminRole } from "../store/AclUtil";
import { useAuth } from "../store/auth/hooks";
import { ProtectedRoute } from "./ProtectedRoute";

export const AdminProtectedRoute = ({ children }) => {
  const auth = useAuth();
  if (!auth.isAuthenticated) {
    // user is not authenticated
    return <Navigate to="/login" />;
  }

  if (!hasAdminRole(auth.user)) {
    return <Navigate to="/app/cases" />;
  }
  return <ProtectedRoute>{children}</ProtectedRoute>;
};
